import { apiFetch } from '@ami/react/core';
import { AmiTaskFilter } from './AmiTaskFilter';

const _baseEndPoint = 'ami-tasks';

export default {
  search: async (filter, page) => {
    const payload = new AmiTaskFilter(filter.toPayload());
    if (filter.isForRecentsWidget) {
      payload.$top = 5;
    } else {
      payload.setPaginationParameters(page);
    }

    const result = await apiFetch(
      `${_baseEndPoint}?${payload.toQueryString()}`
    );
    return result;
  },
};
